module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAAYFBMVEUAAACAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgICAgIDPKpCdAAAAH3RSTlMAUPEwz8MjGe0fEfZfPfjfs491ZzUMA+TXyqubgEkHbef61gAAAJ1JREFUKM/N08sOgyAUhOGjgiBeaq3ae+f937KBJqUEZ+Wm/8r47QaQ/dUKSceUNdLGlAHVFT8Z/9M0kf1nWj/YL5eZViWunJszDoayu8DWwnjRaGdhvI4YnkL5DnRC+QFMQvnkR6VcALc17FJtcN9Cv8Ixocx5sVDuMxuQs2v9WJTFOKEc+gOeAX6ZwrbZVYxNNrLGVpo9g5CqZW9vaUATn3g4mu8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/ic_address_edit.png
// module id = M5mM
// module chunks = 21